export interface IDocuments {
    name: string,
    id: Number,
    description: string,
    requiredValidation: Boolean,
    digitalSupport: Boolean,
    documentoPropietario: string,
    idTipoDocumentoDigital: string,
    idTipoDocumento: string
}

export class Documents implements IDocuments{
    public name: string;
    public idForm?: string;
    
    constructor(
        public id: Number,
        public description: string,
        public requiredValidation: Boolean = true,
        public digitalSupport: Boolean = false,
        public documentoPropietario: string,
        public idTipoDocumentoDigital: string,
        public idTipoDocumento: string
    ){}
}
